import apiClient from './api'
export async function accountingRequest(method: 'get' | 'post', path: string, storeId: string, payload: any = {}) {
  try {
    const response = await apiClient.request({ method, url: `gestock/accounting/${path}`, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      ...(method === 'get' ? { params: { storeId, ...payload } } : { data: { storeId, ...payload } }) })
    return response.data
  } catch (error: any) { throw error.response?.data || error }
}
